module.exports = __webpack_public_path__ + "img/logowhite.a4ea988c.png";